import { render } from "./EmailQuestion.vue?vue&type=template&id=73d0ed06"
import script from "./EmailQuestion.vue?vue&type=script&lang=js"
export * from "./EmailQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__